import React, { useEffect, useRef } from 'react';
import { Modal, Box, Typography, IconButton, Snackbar, Alert, useMediaQuery } from '@mui/material';
import cancelIcon from '../../../assets/images/faqImage/cancel-bl.svg';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
 
const OtpModal = ({ open, handleClose, header, body, handleSnackbarClose, snackbarOpen, snackbarMessage, snackbarSeverity }) => {
  const modalRef: any = useRef(null);
  const isMobile = useMediaQuery('(max-width: 767px)'); // Mobile devices
  const isTablet = useMediaQuery('(max-width: 1024px)'); // Tablet devices
  const headerRef = useRef<HTMLHeadingElement>(null);
 
  useEffect(() => {
    if (open) {
      // Freeze background scrolling
      const scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
    } else {
      // Re-enable background scrolling
      const scrollY = Math.abs(parseInt(document.body.style.top || '0', 10));
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollY); // Restore the scroll position
    }
 
    return () => {
      // Cleanup: Re-enable scrolling on unmount
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';
      document.body.style.width = '';
    };
  }, [open]);
 
  useEffect(() => {
    if (open && headerRef.current) {
      headerRef.current.focus();
    }
  }, [open]);
 
  return (
    <Modal
      open={open}
      onClose={(event, reason) => {
        if (reason === "backdropClick") {
          return;
        }
        handleClose();
      }}
      role="dialog"
      aria-modal="true"
      aria-labelledby='otp-modal-title'
    >
      <Box
        ref={modalRef}
        tabIndex={-1}
        sx={{
          position: "absolute",
          top: isMobile ? '15%' : isTablet ? "16%": "55%",
          left: "50%",
          transform: (isMobile || isTablet) ? "translateX(-50%)" : "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          // width: isMobile ? "90%" : isTablet ? "70%" : "55rem", // Adjust width for mobile and tablet
          borderRadius: "1rem",
          display: "flex",
          flexDirection: "column",
          outline: 0,
          height: isMobile ? '456px' : isTablet ? '492px' : '580px',
          width: isMobile ? '344px' : isTablet ? '720px' : '880px',
        }}
      >
        <Box
          sx={{
            height: (isMobile) ? "120px" : isTablet ? "120px" : "140px", // Adjust height for mobile
            borderRadius: "1rem 1rem 0 0",
            backgroundRepeat: "round",
            px: isMobile ? "1.5rem" : "2.5rem", // Adjust padding for mobile
            justifyContent: "space-between",
            alignItems: "center",
            display: "flex",
          }}
        >
          <Typography
            id="otp-modal-title"
            component={"h1"}
            tabIndex={-1}
            ref={headerRef}
            sx={{
              fontSize: isMobile  ? '20px' : isTablet ? "24px" : "36px", // Adjust font size for mobile
              fontWeight: 700,
              lineHeight: isMobile ? "28px" : isTablet ?  "32px" : "48px", // Adjust line height for mobile
              // fontFamily: "Open Sans",
            }}
          >
            {header}
          </Typography>
          <IconButton
            onClick={handleClose}
            sx={{ height: "2.5rem", width: "2.5rem", color: 'black',
            ':focus-visible': {
              outline: '2px solid black',
              outlineOffset: '2px'
          },
           }}
            aria-label="Close"
          >
            <img src={cancelIcon} alt="close icon" />
          </IconButton>
        </Box>
        <Box
          sx={{
            position: 'relative',
            overflowY: 'auto',
            p: isMobile ? '1.5rem' : '2.5rem', // Adjust padding for mobile
            '&::-webkit-scrollbar': {
              display: 'none', // Hide scrollbar for WebKit browsers
            },
            '-ms-overflow-style': 'none', // Hide scrollbar for Internet Explorer
            'scrollbar-width': 'none', // Hide scrollbar for Firefox
       
          }}
        >
          {body}
 
          {['error', 'warning'].includes(snackbarSeverity) && (
            <Snackbar
              open={snackbarOpen}
              onClose={handleSnackbarClose}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              sx={{
                position: 'absolute',
                top: isMobile ? '0.5rem' : '1rem', // Adjust position for mobile
                right: isMobile ? '0.5rem' : '1rem', // Adjust position for mobile
              }}
            >
              <Alert
                onClose={handleSnackbarClose}
                severity={snackbarSeverity}
                sx={{
                  width: isMobile ? '90%' : '26rem', // Adjust width for mobile
                  borderRadius: '1rem',
                  border: snackbarSeverity === 'error' ? '0.5px solid #B83A32' :
              snackbarSeverity === 'warning' ? '0.5px solid #FFC247' :
              '0.5px solid #224D22',
                  fontSize: '.875rem',
                  fontWeight: 400,
                  lineHeight: '1.25rem',
                  bgcolor: snackbarSeverity === 'error' ? '#FFF1F0' :
                snackbarSeverity === 'warning' ? '#FFF9DD' :
                '#E8F5E9', // Default for success
                }}
                iconMapping={{
                  error: <ErrorIcon htmlColor='#851109' />,
                  success: <CheckCircleIcon />,
                  warning: <ErrorIcon htmlColor='#EB9C00' />,
                }}
              >
                {snackbarMessage}
              </Alert>
            </Snackbar>
          )}
        </Box>
      </Box>
    </Modal>
  );
};
 
export default OtpModal;
 